<template>
  <div id="footer-container">
    <div id="blue-section">
      <b-container>
        <b-row>
          <b-col class="pb-3" cols="12" md="4">
            <div class="text24-white mb-2">Settle in Estonia</div>
            <div>
              <a href="mailto:info@settleinestonia.ee" class="text14-white">
                {{ t("EMAIL") }}: info@settleinestonia.ee
              </a>
            </div>
            <div>
              <a href="https://www.facebook.com/settleinestonia" class="text14-white">
                Facebook
              </a>
            </div>
            <div>
              <a href="https://www.eesti.ee/syndmusteenused/et/eestis-kohanemine" class="text14-white">
                {{ t("STATE_PROVIDED_SERVICES") }}
              </a>
            </div>
            <div>
              <a href="https://issuu.com/settleinestonia" class="text14-white">
                <span class="font-weight-bold">{{ t("FOOTER_TRAINING_MATERIALS") }}:</span> ISSUU
              </a>
            </div>
            <div>
              <a href="https://www.youtube.com/@settleestonia1437" class="text14-white">
                YouTube
              </a>
            </div>
            <div>
              <a href="https://e-koolikott.ee/et/search?q=settle%20&minAdded=2009&maxAdded=2024&sort=relevance" class="text14-white">
                E-koolikott
              </a>
            </div>
          </b-col>

          <b-col class="pb-3" cols="12" md="4">
            <div class="text24-white mb-2">{{ t("FOOTER_IMPORTANT_CONTACTS") }}</div>
            <div>
              <a href="https://www.politsei.ee" class="text14-white">
                <span class="font-weight-bold">{{ t("POLICE_INFORMATION_SERVICE") }}: 1247</span>
              </a>
            </div>
            <div>
              <a href="https://www.politsei.ee/en/migration-consultants" class="text14-white">
                {{ t("MIGRATION_CONSULTANTS") }}
              </a>
            </div>
            <div>
              <span class="text14-white">
                <span class="font-weight-bold">{{ t("STATE_INFORMATION_SERVICE") }}: 1247</span>, {{ t("ABROAD_DIAL") }}: (+372)&nbsp;600&nbsp;1247
              </span>
            </div>
            <div>
              <a href="https://www.kriis.ee" class="text14-white">
                Kriis.ee
              </a>
            </div>
          </b-col>

          <b-col class="pb-3" cols="12" md="4">
            <div class="text24-white mb-2">{{ t("EMERGENCY_CONTACTS") }}</div>
            <div>
              <span class="text14-white">
                <span class="font-weight-bold">{{ t("EMERGENCY_CONTACT") }}: 112</span>
              </span>
            </div>
            <div>
              <a href="https://www.lasteabi.ee" class="text14-white">
                <span class="font-weight-bold">{{ t("CHILD_HELPLINE") }}: 116&nbsp;111</span>, {{ t("ABROAD_DIAL") }}: (+372)&nbsp;600&nbsp;4434
              </a>
            </div>
            <div>
              <a href="https://www.palunabi.ee/vota-uhendust" class="text14-white">
                <span class="font-weight-bold">{{ t("VICTIM_ASSISTANCE") }}: 116&nbsp;006</span>
              </a>
            </div>
            <div>
              <a href="https://naisteliin.ee" class="text14-white">
                <span class="font-weight-bold">{{ t("WOMEN_HELPLINE") }}: 1492</span>
              </a>
            </div>
            <div>
              <a href="https://www.1220.ee" class="text14-white">
                <span class="font-weight-bold">{{ t("FAMILY_DOCTOR_ADVICE_LINE") }}: 1220</span>, {{ t("ABROAD_DIAL") }}: (+372)&nbsp;634&nbsp;6630
              </a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="text-center">
      <img
          class="settle-image"
          src="@/assets/settle_estonia_horizontal_negative.svg"
          alt="settle estonia"
      />
      <img src="@/assets/kultuurimin_3lovi_eng_pms.svg"
      alt="logo Ministry of culture"/>
      <img id="logo-sticky" src="@/assets/el_sotsiaalfond_vertikaalne.jpg" alt="logo"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#blue-section {
  background-color: $color-blue;
  padding-bottom: 50px;
  padding-top: 50px;
  padding-left: 20px;
}

.settle-image {
  max-width: 305px;
}

#logo-sticky {
  position: relative;
  bottom: 0;
  end: 0;
}
</style>
<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n();
</script>
